import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import talukderLogo from "../../asset/images/Logo/talukderName.png";
import { Link, NavLink } from "react-router-dom";

const CareerNavigation = () => {
  return (
    <>

      <Navbar className='carrerNav' data-bs-theme="light"> 
        <Container>
          <Navbar.Brand href="#home">
            <Link to="/">
              <Navbar.Brand href="#home">
                <img
                  alt="logo"
                  className="t_logo"
                  src={talukderLogo}
                  margin={{ padding: "10px 0" }}
                /> 
              </Navbar.Brand> 
            </Link> 
          </Navbar.Brand> 
          <Nav className="ml-auto">
            <Nav.Link>
              <NavLink to="/" className="careerMenu">
                Home 
              </NavLink>{" "}
            </Nav.Link>
            <Nav.Link>
              <NavLink to="/about" className="careerMenu">
                About Us
              </NavLink>
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
   
    </>
  );
}

export default CareerNavigation